import * as mutationTypes from './mutation-types'
import api from '@/store/api/sms'

const initialState = () => ({
    messages: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        messages: state => state.messages.data,
        pagination: state => state.messages.pagination
    },
    actions: {
        /**
         * @param {{}} params
         * @returns {Promise<*>}
         */
        listMessages: async ({commit, dispatch}, params) => {
            try {
                const response = await api.listMessages(params)
                commit(mutationTypes.SET_SMS_MESSAGES, response)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetMessages: ({commit}) => commit(mutationTypes.RESET_SMS_MESSAGES)
    },
    mutations: {
        [mutationTypes.RESET_SMS_MESSAGES]: (state) => Object.assign(state, initialState()),
        [mutationTypes.SET_SMS_MESSAGES]: (state, data) => state.messages = data
    }
}
